import './Accordion.scss';

import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';

import Arrow from './Arrow';

function Accordion({ content, title }) {
  const [setActive, setActiveState] = useState(undefined);
  const [setHeight, setHeightState] = useState('0px');
  const [setRotate, setRotateState] = useState('accordion__icon rotate');

  const contentRef = useRef(null);

  function toggleAccordion() {
    setActiveState(!setActive ? 'active' : '');
    setHeightState(
      // TO DO: Rever regra da dupla exclamação com o time
      // eslint-disable-next-line

      setActive ? 0 : `${contentRef.current.scrollHeight + contentRef.current.clientHeight}px`
    );
    setRotateState(!setActive ? 'accordion__icon' : 'accordion__icon rotate');
  }

  return (
    <div className="accordion__section">
      <button type="button" className={`accordion ${setActive}`} onClick={toggleAccordion}>
        <p className="accordion__title">{title}</p>
        <Arrow className={setRotate} width={10} fill="#777" />
      </button>
      <div ref={contentRef} style={{ maxHeight: `${setHeight}` }} className="accordion__content">
        <div>{content}</div>
      </div>
    </div>
  );
}

Accordion.propTypes = {
  content: PropTypes.element,
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.string])
};

export default Accordion;
